import { api } from "./Api";
import { establishmentQuery, getSelectedEstablishment } from "./selectedEstablishment";

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

/** Público do disparo */
export type PushAudience = "online" | "offline";

/** Cota de um público */
export interface IAudienceQuota {
  limit: number;
  used: number;
  remaining: number;
  /** Quantas pessoas esse público alcança hoje */
  audienceSize: number;
}

export interface INotificationStats {
  planType: "insight" | "connection" | "pulse" | "wave" | "none";
  documentsStatus: "not_sent" | "pending" | "approved" | "rejected";
  /** true = plano permite push, mas os documentos ainda não foram aprovados */
  pendingApproval: boolean;
  /** Nome do estabelecimento em foco, quando há apenas um selecionado */
  estabilishmentName?: string | null;

  /** Cotas independentes por público (Connection: 15 online / 5 offline) */
  online: IAudienceQuota;
  offline: IAudienceQuota;

  // campos mantidos por compatibilidade — espelham o público online
  limit: number;
  used: number;
  remaining: number;
  activeUsers: number;
}

export interface IRestNotificationStats {
  data: { code: number; message: string; data: INotificationStats };
}

export interface IRestNotificationSend {
  data: {
    code: number;
    message: string;
    data: { sent: number; errors: number; usedThisMonth: number; limit: number };
  };
}

export const getNotificationStats = () =>
  api.get(`/pt_BR/establishment/notification/stats${establishmentQuery()}`, authHeader());

export const postNotification = (
  title: string,
  text: string,
  audience: PushAudience = "online",
) =>
  api.post(
    "/pt_BR/establishment/notification",
    // estabelecimento selecionado no painel — o disparo alcança só os
    // clientes dele, e não os de todos os locais do usuário
    { title, text, audience, estabilishment: getSelectedEstablishment() || undefined },
    authHeader(),
  );